export const radiologicProducts = [
  {
    title: "RL-LogicLink",
    description: {
      sv: "Kraftfullt konfigurations- och programmeringsverktyg för hela Radiologic-systemet.",
      en: "Powerful configuration and programming tool for the entire Radiologic system.",
    },
    image: "/images/products/RL/logiclink/1.png",
    gallery: [
      "/images/products/RL/logiclink/1.png",
      "/images/products/RL/logiclink/2.png",
      "/images/products/RL/logiclink/3.png",
    ],
    slug: "rl-logiclink",
    category: "RADIOLOGIC",
    features: [
      {
        title: {
          sv: "Programmera själv – eller låt oss göra jobbet",
          en: "Program it yourself – or let us do the work",
        },
        description: {
          sv: "Skapa och ändra funktioner själv i LogicLink, eller låt oss konfigurera systemet färdigt innan leverans.",
          en: "Create and modify functions yourself in LogicLink, or let us configure the system before delivery.",
        },
      },
      {
        title: { sv: "Intuitiv programmering", en: "Intuitive programming" },
        description: {
          sv: "Grafiskt gränssnitt och inbyggd PLC-logik gör programmeringen enkel, snabb och överskådlig.",
          en: "Graphical interface and built-in PLC logic makes programming simple, fast and clear.",
        },
      },
      {
        title: { sv: "Designa egna operatörsbilder", en: "Design your own operator screens" },
        description: {
          sv: "Skapa egna gränssnitt till RL Display med symboler, bilder, färger och knappar.",
          en: "Create your own interfaces for RL Display with symbols, images, colors and buttons.",
        },
      },
      {
        title: {
          sv: "Ett verktyg för hela Radiologic-systemet",
          en: "One tool for the entire Radiologic system",
        },
        description: {
          sv: "Konfigurera, hantera och uppdatera samtliga Radiologic-enheter i samma projekt.",
          en: "Configure, manage and update all Radiologic units in the same project.",
        },
      },
    ],
  },
  {
    title: "RL-DISPLAY",
    description: {
      sv: "Intelligent operatörspanel med anpassningsbar pekskärm för styrning och visualisering.",
      en: "Intelligent operator panel with customizable touchscreen for control and visualization.",
    },
    image: "/images/products/RL/display/1.png",
    gallery: [
      "/images/products/RL/display/1.png",
      "/images/products/RL/display/2.png",
      "/images/products/RL/display/3.png",
    ],
    slug: "rl-display",
    category: "RADIOLOGIC",
    pdfs: [
      {
        label: { sv: "Datablad – RL Display", en: "Datasheet – RL Display" },
        url: "/pdfs/radiologic/RL-Display-JonSys.pdf",
      },
      { label: "TDS – RL Mount", url: "/pdfs/radiologic/RL-MOUNT TDS.pdf" },
    ],
    features: [
      {
        title: { sv: "Designa ditt eget användargränssnitt", en: "Design your own user interface" },
        description: {
          sv: "Skapa egna operatörsbilder med symboler, bilder, knappar och statusindikeringar.",
          en: "Create your own operator screens with symbols, images, buttons and status indicators.",
        },
      },
      {
        title: { sv: "Full integration med LogicLink", en: "Full integration with LogicLink" },
        description: {
          sv: "Programmera logik, funktioner och grafiska gränssnitt direkt i samma LogicLink-projekt.",
          en: "Program logic, functions and graphical interfaces directly in the same LogicLink project.",
        },
      },
      {
        title: { sv: "Övervaka och styr i realtid", en: "Monitor and control in real time" },
        description: {
          sv: "Visa mätvärden, larm, status och processinformation direkt på pekskärmen via kommunikation inom traditionell radiostyrningsteknik.",
          en: "Display measured values, alarms, status and process information directly on the touchscreen via communication within traditional radio remote control technology.",
        },
      },
      {
        title: { sv: "Utvecklad för industriella miljöer", en: "Developed for industrial environments" },
        description: {
          sv: "Robust konstruktion och tydligt gränssnitt för industri, entreprenadmaskiner och krävande applikationer.",
          en: "Robust construction and clear interface for industry, construction machines and demanding applications.",
        },
      },
    ],
  },
  {
    title: "RL-RC10",
    description: {
      sv: "Programmerbar handsändare med upp till 20 funktioner och tydlig LED-återkoppling.",
      en: "Programmable hand transmitter with up to 20 functions and clear LED feedback.",
    },
    image: "/images/products/RL/rc10/1.png",
    gallery: [
      "/images/products/RL/rc10/1.png",
      "/images/products/RL/rc10/2.png",
      "/images/products/RL/rc10/3.png",
      "/images/products/RL/rc10/4.png",
    ],
    slug: "rl-rc10",
    category: "RADIOLOGIC",
    features: [
      {
        title: { sv: "Programmeras i LogicLink", en: "Programmed in LogicLink" },
        description: {
          sv: "Konfigurera funktioner, knappar och beteenden direkt i LogicLink efter applikationens behov.",
          en: "Configure functions, buttons and behaviors directly in LogicLink according to the application's needs.",
        },
      },
      {
        title: { sv: "Tydlig återkoppling till användaren", en: "Clear feedback to the user" },
        description: {
          sv: "LED-indikatorer visar status, bekräftelser och larm direkt på handsändaren.",
          en: "LED indicators show status, confirmations and alarms directly on the hand transmitter.",
        },
      },
      {
        title: { sv: "Utvecklad för professionell styrning", en: "Developed for professional control" },
        description: {
          sv: "Upp till 20 programmerbara funktioner för maskiner, processer och automationssystem.",
          en: "Up to 20 programmable functions for machines, processes and automation systems.",
        },
      },
      {
        title: { sv: "Lång drifttid och enkel laddning", en: "Long operating time and easy charging" },
        description: {
          sv: "Uppladdningsbara batterier och enkel laddning via Micro-USB för smidig daglig användning.",
          en: "Rechargeable batteries and easy charging via Micro-USB for convenient daily use.",
        },
      },
    ],
  },
  {
    title: "RL-RC8",
    description: {
      sv: "Kompakt mobil operatörsenhet med display, programmerbara knappar och tydlig återkoppling.",
      en: "Compact mobile operator unit with display, programmable buttons and clear feedback.",
    },
    image: "/images/products/RL/rc8/1.png",
    gallery: [
      "/images/products/RL/rc8/1.png",
      "/images/products/RL/rc8/2.png",
      "/images/products/RL/rc8/3.png",
      "/images/products/RL/rc8/4.png",
    ],
    slug: "rl-rc8",
    category: "RADIOLOGIC",
    pdfs: [
      {
        label: { sv: "Datablad – RL RC8", en: "Datasheet – RL RC8" },
        url: "/pdfs/radiologic/RL-RC8-JonSys.pdf",
      },
    ],
    features: [
      {
        title: { sv: "Display med tydlig återkoppling", en: "Display with clear feedback" },
        description: {
          sv: "Visar symboler, statusmeddelanden och systeminformation direkt i handen.",
          en: "Displays symbols, status messages and system information directly in the hand.",
        },
      },
      {
        title: { sv: "Programmeras i LogicLink", en: "Programmed in LogicLink" },
        description: {
          sv: "Konfigurera knappar, menyer och funktioner direkt i LogicLink.",
          en: "Configure buttons, menus and functions directly in LogicLink.",
        },
      },
      {
        title: { sv: "Flera funktioner i en kompakt enhet", en: "Multiple functions in a compact unit" },
        description: {
          sv: "Programmerbara funktionsknappar och menyer gör den flexibel för många styrsystem.",
          en: "Programmable function buttons and menus make it flexible for many control systems.",
        },
      },
      {
        title: { sv: "Utvecklad för professionell användning", en: "Developed for professional use" },
        description: {
          sv: "Ergonomisk design, trådlös laddning och robust konstruktion för daglig användning.",
          en: "Ergonomic design, wireless charging and robust construction for daily use.",
        },
      },
    ],
  },
  {
    title: "RL-PRIO",
    description: {
      sv: "Intelligent I/O- och logikenhet med PLC-funktionalitet för flexibla automationslösningar.",
      en: "Intelligent I/O and logic unit with PLC functionality for flexible automation solutions.",
    },
    image: "/images/products/RL/prio/1.png",
    gallery: ["/images/products/RL/prio/1.png"],
    slug: "rl-prio",
    category: "RADIOLOGIC",
    pdfs: [
      {
        label: { sv: "Datablad – RL PRIO (sv)", en: "Datasheet – RL PRIO (sv)" },
        url: "/pdfs/radiologic/Datablad RL-PRIO sv.pdf",
      },
    ],
    features: [
      {
        title: { sv: "Intelligent styrning och PLC-logik", en: "Intelligent control and PLC logic" },
        description: {
          sv: "Kombinerar in- och utgångar med PLC-logik för avancerade styrfunktioner direkt i enheten.",
          en: "Combines inputs and outputs with PLC logic for advanced control functions directly in the unit.",
        },
      },
      {
        title: { sv: "Programmeras i LogicLink", en: "Programmed in LogicLink" },
        description: {
          sv: "Konfigurera I/O, PLC-logik och funktioner i ett grafiskt och lättanvänt verktyg.",
          en: "Configure I/O, PLC logic and functions in a graphical and easy-to-use tool.",
        },
      },
      {
        title: {
          sv: "Trådlös integration i Radiologic-systemet",
          en: "Wireless integration in the Radiologic system",
        },
        description: {
          sv: "Kommunicerar med övriga Radiologic-enheter och bygger kompletta trådlösa automationslösningar.",
          en: "Communicates with other Radiologic units and builds complete wireless automation solutions.",
        },
      },
      {
        title: { sv: "Flexibel för framtidens automation", en: "Flexible for the automation of the future" },
        description: {
          sv: "Kan användas i allt från fristående maskiner till större och mer avancerade styrsystem.",
          en: "Can be used in everything from standalone machines to larger and more advanced control systems.",
        },
      },
    ],
  },
  {
    title: "RL-ROUTER",
    description: {
      sv: "Kommunikationscentral för uppkoppling, fjärråtkomst och dataöverföring i Radiologic-systemet.",
      en: "Communication hub for connectivity, remote access and data transfer in the Radiologic system.",
    },
    image: "/images/products/RL/router/1.png",
    gallery: ["/images/products/RL/router/1.png"],
    slug: "rl-router",
    category: "RADIOLOGIC",
    pdfs: [
      {
        label: { sv: "Datablad – RL Router", en: "Datasheet – RL Router" },
        url: "/pdfs/radiologic/RL-Router-JonSys.pdf",
      },
    ],
    features: [
      {
        title: { sv: "Koppla upp dina automationssystem", en: "Connect your automation systems" },
        description: {
          sv: "Anslut Radiologic-systemet till lokala nätverk eller internet via Ethernet och LTE.",
          en: "Connect the Radiologic system to local networks or the internet via Ethernet and LTE.",
        },
      },
      {
        title: { sv: "Utvecklad för industriell kommunikation", en: "Developed for industrial communication" },
        description: {
          sv: "Stöd för TCP/IP, Modbus TCP och HTTP gör den enkel att integrera med industriella system.",
          en: "Support for TCP/IP, Modbus TCP and HTTP makes it easy to integrate with industrial systems.",
        },
      },
      {
        title: { sv: "Övervaka och analysera i realtid", en: "Monitor and analyze in real time" },
        description: {
          sv: "Skicka processdata, status och larm till externa system för visualisering och analys.",
          en: "Send process data, status and alarms to external systems for visualization and analysis.",
        },
      },
      {
        title: { sv: "En naturlig del av Radiologic", en: "A natural part of Radiologic" },
        description: {
          sv: "Samverkar med övriga Radiologic-enheter för ett komplett och uppkopplat automationssystem.",
          en: "Works together with other Radiologic units for a complete and connected automation system.",
        },
      },
    ],
  },
  {
    title: "RL-PROP44",
    description: {
      sv: "Avancerad PLC- och I/O-modul för hantering av både digitala och analoga signaler.",
      en: "Advanced PLC and I/O module for handling both digital and analog signals.",
    },
    image: "/images/products/RL/prop44/1.png",
    gallery: ["/images/products/RL/prop44/1.png"],
    slug: "rl-prop44",
    category: "RADIOLOGIC",
    pdfs: [
      {
        label: { sv: "Datablad – RL PROP44", en: "Datasheet – RL PROP44" },
        url: "/pdfs/radiologic/RL-PROP44.pdf",
      },
    ],
    features: [
      {
        title: {
          sv: "Hantera både digitala och analoga signaler",
          en: "Handle both digital and analog signals",
        },
        description: {
          sv: "Kombinerar digitala I/O med analoga signaler för sensorer, ventiler och processteknik.",
          en: "Combines digital I/O with analog signals for sensors, valves and process technology.",
        },
      },
      {
        title: { sv: "Programmeras i LogicLink", en: "Programmed in LogicLink" },
        description: {
          sv: "Skapa PLC-logik, konfigurera I/O och anpassa funktioner direkt i LogicLink.",
          en: "Create PLC logic, configure I/O and customize functions directly in LogicLink.",
        },
      },
      {
        title: { sv: "En del av Radiologic-ekosystemet", en: "Part of the Radiologic ecosystem" },
        description: {
          sv: "Kommunicerar trådlöst med övriga Radiologic-enheter i samma plattform.",
          en: "Communicates wirelessly with other Radiologic units on the same platform.",
        },
      },
      {
        title: { sv: "Skalbar för avancerad automation", en: "Scalable for advanced automation" },
        description: {
          sv: "Passar både fristående maskiner och större automationssystem med höga krav på flexibilitet.",
          en: "Suitable for both standalone machines and larger automation systems with high demands for flexibility.",
        },
      },
    ],
  },
];
